module.exports = __webpack_public_path__ + "static/media/live_classes_eamcet.5a63600a.png";